import type { FC } from 'react';

import { DynamicImage } from '@wwe-portal/ui/components/dynamic-image';
import { cn } from '@wwe-portal/ui/lib/lib';
import eventLogoWebp from '@wwe-portal/ui/assets/images/offer/event-logo.png';

interface SuperStarLogoProps {
  className?: string;
  logoUrl: string;
}
export const SuperStarLogo: FC<SuperStarLogoProps> = ({
  className,
  logoUrl,
}) => {
  return (
    <div
      className={cn(
        '-left-[17px] -top-2 inline-flex h-[34px] w-[34px] items-center justify-center border-none',
        className
      )}
    >
      <DynamicImage
        alt="Logo"
        className="h-full w-full object-contain"
        defaultUrl={eventLogoWebp}
        dynamicUrl={logoUrl}
        resizedWidth={64}
      />
    </div>
  );
};
